import React from "react";
import gallery1 from "../../../assets/card-frame.png";
import gallery2 from "../../../assets/gallery-2.png";
import gallery3 from "../../../assets/gallery-3.png";
import gallery4 from "../../../assets/gallery-4.png";
import gallery5 from "../../../assets/gallery-5.png";
import gallery6 from "../../../assets/gallery-6.png";
import gallery7 from "../../../assets/gallery-7.png";
import gallery8 from "../../../assets/gallery-8.png";
import stamp from "../../../assets/stamp.png";

const galleryImages = [
  { src: gallery1, alt: "Gallery frame", w: 375, h: 461, offsetY: 96, stamp: true },
  { src: gallery2, alt: "Gallery margin", w: 405, h: 571, offsetY: -96 },
  { src: gallery3, alt: "Gallery container", w: 475, h: 677 },
  { src: gallery4, alt: "Gallery container 6", w: 664, h: 863 },
  { src: gallery5, alt: "Gallery image 6", w: 444, h: 339, offsetY: -96 },
  { src: gallery6, alt: "Gallery image 7", w: 620, h: 517 },
  { src: gallery7, alt: "Gallery image 8", w: 368, h: 255, offsetY: -96 },
  { src: gallery8, alt: "Gallery image 9", w: 266, h: 291, offsetY: 96 },
];

const DESIGN_H = 900;
const vh = (px) => {
  const v = ((px / DESIGN_H) * 100).toFixed(3);
  return px >= 0 ? `min(${px}px, ${v}svh)` : `max(${px}px, ${v}svh)`;
};

export default function Container() {
  return (
    <div
      // CHANGED: Added max-md:items-start, max-md:gap-8, and dynamic responsive paddings using CSS variables
      className="flex flex-none items-center max-md:items-start max-md:gap-8 overflow-visible pl-0 md:pl-[var(--desktop-pl)] pr-0 md:pr-[var(--desktop-pr)]"
      data-name="Container"
      style={{
        gap: vh(122),
        height: vh(703),
        "--desktop-pl": vh(250),
        "--desktop-pr": vh(13),
      }}
    >
      {galleryImages.map((image) => (
        <div
          key={image.src}
          // CHANGED: max-md:items-start to ensure alignment matches parent track
          className="gallery-item flex-none h-full flex items-center max-md:items-start overflow-visible pointer-events-none select-none"
        >
          <div
            className={image.stamp ? "relative inline-block overflow-visible" : ""}
            style={
              image.offsetY
                ? { position: "relative", top: vh(image.offsetY) }
                : undefined
            }
          >
            <img
              src={image.src}
              alt={image.alt}
              draggable="false"
              className="object-contain block pointer-events-none select-none"
              style={{
                maxWidth: vh(image.w),
                maxHeight: vh(image.h),
                WebkitUserDrag: "none",
              }}
              loading="eager"
              decoding="async"
            />

            {image.stamp && (
              <img
                src={stamp}
                alt="Gallery stamp"
                draggable="false"
                className="absolute z-20 pointer-events-none select-none"
                style={{
                  width: vh(140),
                  bottom: vh(-18),
                  right: vh(-14),
                  height: "auto",
                }}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}